import m from "mithril";
import {SyntheticItem} from '../../model/items/synthetic'

export function syntheticItemView(c:SyntheticItem){
	if (c.isVisible()) {
        return m(
            'div.synthetic',
            {
                'data-value': c.getVariable(),
            },
            String(c.getVariable())
        );
    }
    return null;
}